import PropTypes from 'prop-types'

import { EMPTY_PLACEHOLDER } from '../constants'

const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
})

optionPropType.defaultProps = {
  label: EMPTY_PLACEHOLDER,
}

export default optionPropType
